import { ElementRef, Injectable, inject } from '@angular/core';
import { BlobService, CanvasService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class ScreenshotService {
  private blobService = inject(BlobService);
  private canvasService = inject(CanvasService);

  takeScreenshot(source: ElementRef): Blob {
    const newCanvas = document.createElement('canvas');
    newCanvas.width = this.canvasService.screen().width;
    newCanvas.height = this.canvasService.screen().height;

    document.body.appendChild(newCanvas);
    newCanvas.style.display = 'none';

    const video: HTMLVideoElement = source.nativeElement;
    const resize = this.recalculateSize(video, newCanvas);

    newCanvas
      .getContext('2d')
      .drawImage(
        video,
        resize.xShift,
        resize.yShift,
        resize.width,
        resize.height,
        0,
        0,
        newCanvas.width,
        newCanvas.height,
      );

    const blob = this.blobService.getImageBlob(
      newCanvas.toDataURL('image/png'),
    );

    document.body.removeChild(newCanvas);
    return blob;
  }

  recalculateSize(video: HTMLVideoElement, referenceCanvas: HTMLCanvasElement) {
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    const canvasWidth = referenceCanvas.width;
    const canvasHeight = referenceCanvas.height;

    let width: number;
    let height: number;
    let xShift = 0;
    let yShift = 0;

    if (videoWidth / canvasWidth > videoHeight / canvasHeight) {
      height = videoHeight;
      width = (videoHeight * canvasWidth) / canvasHeight;
      xShift = (videoWidth - width) / 2;
    } else {
      width = videoWidth;
      height = (videoWidth * canvasHeight) / canvasWidth;
      yShift = (videoHeight - height) / 2;
    }

    return { width, height, xShift, yShift };
  }
}
